<script>
import MetisMenu from "metismenujs/dist/metismenujs";
import { menuItems } from "./horizontal-menu";

// import { menuItems } from "./menu";

/**
 * Sidenav component
 */
export default {
  data() {
    return {
      // menuItems: menuItems,
      menuData: null,
    };
  },
  computed: {
    menuItems() {
      return [
        {
          id: 1,
          label: "Dashboard",
          icon: "bx-home-circle",
          link: "/dashboard",
          visible: true,
        },
        {
          id: 2,
          label: "Info",
          isTitle: true,
        },
        {
          id: 5,
          label: "Info",
          icon: "bx-area",
          subItems: [
            {
              id: 1,
              label: "country",
              link: "/info/country",
              parentId: 5,
              visible: this.$can("CountryView", "permissions"),
            },
            {
              id: 2,
              label: "oblast",
              link: "/info/oblast",
              parentId: 5,
              visible: this.$can("OblastView", "permissions"),
            },
            {
              id: 3,
              label: "region",
              link: "/info/region",
              parentId: 5,
              visible: this.$can("RegionView", "permissions"),
            },
            // {
            //   id: 4,
            //   label: "mfy",
            //   link: "/info/mfy",
            //   parentId: 5,
            // },
            // {
            //   id: 5,
            //   label: "mfystate",
            //   link: "/info/mfystate",
            //   parentId: 5,
            // },
            // {
            //   id: 6,
            //   label: "nationality",
            //   link: "/info/nationality",
            //   parentId: 5,
            // },
            {
              id: 7,
              label: "oked",
              link: "/info/oked",
              parentId: 5,
              visible: this.$can("OkedView", "permissions"),
            },
            // {
            //   id: 8,
            //   label: "regiongroup",
            //   link: "/info/regiongroup",
            //   parentId: 5,
            // },
            // {
            //   id: 9,
            //   label: "regionstate",
            //   link: "/info/regionstate",
            //   parentId: 5,
            // },
            // {
            //   id: 10,
            //   label: "regiontype",
            //   link: "/info/regiontype",
            //   parentId: 5,
            // },
            // {
            //   id: 11,
            //   label: "street",
            //   link: "/info/street",
            //   parentId: 5,
            // },
            // {
            //   id: 12,
            //   label: "streethouse",
            //   link: "/info/streethouse",
            //   parentId: 5,
            // },
            // {
            //   id: 13,
            //   label: "streethousestate",
            //   link: "/info/streethousestate",
            //   parentId: 5,
            // },
            // {
            //   id: 14,
            //   label: "streetstate",
            //   link: "/info/streetstate",
            //   parentId: 5,
            // },
          ],
        },
        {
          id: 3,
          label: "InfoCurriculaSetting",
          icon: "bx bx-clipboard",
          subItems: [
            {
              id: 7,
              label: "department",
              link: "/info/department",
              parentId: 3,
              visible: this.$can("DepartmentView", "permissions"),
            },
            // {
            //   id: 8,
            //   label: "educationlanguage",
            //   link: "/info/educationlanguage",
            //   parentId: 3,
            //   visible: true,
            // },
            {
              id: 9,
              label: "itemofexpense",
              link: "/info/itemofexpense",
              parentId: 3,
              visible: this.$can("ItemOfExpenseView", "permissions"),
            },

            {
              id: 17,
              label: "schoolgroupcontigent",
              link: "/info/schoolgroupcontigent",
              parentId: 3,
              visible: this.$can("SchoolGroupContingentView", "permissions"),
            },
            // {
            //   id: 18,
            //   label: "schoollegalform",
            //   link: "/info/schoollegalform",
            //   parentId: 3,
            // },
            {
              id: 19,
              label: "schooltype",
              link: "/info/schooltype",
              parentId: 3,
              visible: this.$can("SchoolTypeView", "permissions"),
            },

            {
              id: 24,
              label: "unitofmeasure",
              link: "/info/unitofmeasure",
              parentId: 3,
              visible: this.$can("UnitOfMeasureView", "permissions"),
            },
            {
              id: 25,
              label: "product",
              link: "/info/product",
              parentId: 3,
              visible: this.$can("ProductView", "permissions"),
            },
            {
              id: 26,
              label: "productcategory",
              link: "/info/productcategory",
              parentId: 3,
              visible: this.$can("ProductCategoryView", "permissions"),
            },
            {
              id: 27,
              label: "TradeTypeRestriction",
              link: "/info/tradetyperestriction",
              parentId: 3, 
              visible: this.$can("ProductCategoryView", "permissions"),
            },
            // {
            //   id: 27,
            //   label: "schoolsubjectgroup",
            //   link: "/info/schoolsubjectgroup",
            //   parentId: 3,
            // },
          ],
        },

        {
          id: 6,
          label: "Document",
          isTitle: true,
        },
        {
          id: 7,
          label: "DocumentForThisYear",
          icon: "bx bx-dock-top",

          subItems: [
            {
              id: 1,
              label: "purchaserequisition",
              link: "/document/purchaserequisition",
              parentId: 7,
              visible: this.$can("PurchaseRequisitionView", "permissions"),
            },
            {
              id: 2,
              label: "PurchaseRequisitionStatus",
              link: "/document/purchaserequisition/otherstatus.vue",
              parentId: 7,
              visible: this.$can(
                "PurchaseRequisitionOtherStatusView",
                "permissions"
              ),
            },

            {
              id: 5,
              label: "PurchaseRequisitionTotal",
              link: "/document/purchaserequisitiontotal",
              parentId: 7,
              visible: this.$can("PurchaseRequisitionTotalView", "permissions"),
            },
          ],
        },

        {
          id: 13,
          label: "DocumentForNextYear",
          icon: "bx bx-dock-top",

          subItems: [
            {
              id: 3,
              label: "PurchaseRequisitionForNextYear",
              link: "/document/purchaserequisitionfornextyear",
              parentId: 13,
              visible: this.$can(
                "PurchaseRequisitionForNextYearView",
                "permissions"
              ),
            },
            {
              id: 4,
              label: "PurchaseRequisitionStatusForNextYear",
              link: "/document/purchaserequisitionfornextyear/otherstatus.vue",
              parentId: 13,
              visible: this.$can(
                "PurchaseRequisitionForNextYearOtherStatusView",
                "permissions"
              ),
            },
            {
              id: 5,
              label: "PurReqTotalForNextYear",
              link: "/document/purreqtotalfornextyear",
              parentId: 13,
              visible: this.$can("PurReqTotalForNextYearView", "permissions"),
            },
          ],
        },
        {
          id: 14,
          label: "Document",
          icon: "bx bx-dock-top",
          subItems: [
            {
              id: 1,
              label: "PurReqPlacement",
              link: "/document/purreqplacement",
              parentId: 14,
              visible: this.$can("PurReqPlacementView", "permissions"),
            },
          ],
        },

        {
          id: 43,
          label: "Reports",
          isTitle: true,
        },
        {
          id: 42,
          label: "Reports",
          icon: "bx bxs-report",
          subItems: [
            {
              id: 48,
              label: "AuctionInfoByStatus",
              link: "/Reports/GetAllUzexLot",
              parentId: 42,
              visible: true
            },
            
            {
              id: 49,
              label: "auctioninfobystatus",
              // link: "/Reports/AuctionInfoByStatus",
              parentId: 42,
              visible:true,

              subItems:[
              {
              label: "GetAuctionInfoByStatusAuction",
              link: "/Reports/GetAuctionInfoByStatusAuction",
              parentId: 49,
              visible:true,
            },
            {
              label: "GetAuctionInfoByStatusShop",
              link: "/Reports/GetAuctionInfoByStatusShop",
              parentId: 49,
              visible:true,
            },
            {
              label: "GetAuctionInfoByStatusEtender",
              link: "/Reports/GetAuctionInfoByStatusEtender",
              parentId: 49,
              visible:true,
            },
              ]
            },
            // {
            //   // id: 51,
            //   label: "GetAuctionInfoByStatusAuction",
            //   link: "/Reports/GetAuctionInfoByStatusAuction",
            //   parentId: 42,
            //   visible:true,
            // },
            // {
            //   // id: 51,
            //   label: "GetAuctionInfoByStatusShop",
            //   link: "/Reports/GetAuctionInfoByStatusShop",
            //   parentId: 42,
            //   visible:true,
            // },
            // {
            //   // id: 51,
            //   label: "GetAuctionInfoByStatusEtender",
            //   link: "/Reports/GetAuctionInfoByStatusEtender",
            //   parentId: 42,
            //   visible:true,
            // },
            {
              id: 34,
              label: "auctionlotinfo",
              link: "/Reports/AuctionLotInfo",
              parentId: 42,
              visible: this.$can(
                "GetReportPurchaseRequisitionView",
                "permissions"
              ),
            },
            {
              id: 51,
              label: "auctioninfobyprovider",
              // link: "/Reports/AuctionInfoByProvider",
              parentId: 42,
              visible: this.$can(
                "GetReportPurchaseRequisitionView",
                "permissions"
              ),
              subItems:[
                {
                  label: "GetAuctionInfoByProviderPlatformAuction",
                  link: "/Reports/GetAuctionInfoByProviderPlatformAuction",
                  parentId: 51,
                  visible:true
                },
                {
                  label: "GetAuctionInfoByProviderPlatformShop",
                  link: "/Reports/GetAuctionInfoByProviderPlatformShop",
                  parentId: 51,
                  visible:true
                },
                {
                  label: "GetAuctionInfoByProviderPlatformEtender",
                  link: "/Reports/GetAuctionInfoByProviderPlatformEtender",
                  parentId: 51,
                  visible:true
                },
              ]
            },
            // {
            //   // id: 51,
            //   label: "GetAuctionInfoByProviderPlatformAuction",
            //   link: "/Reports/GetAuctionInfoByProviderPlatformAuction",
            //   parentId: 42,
            //   visible:true
            // },
            // {
            //   // id: 51,
            //   label: "GetAuctionInfoByProviderPlatformShop",
            //   link: "/Reports/GetAuctionInfoByProviderPlatformShop",
            //   parentId: 42,
            //   visible:true
            // },
            // {
            //   // id: 51,
            //   label: "GetAuctionInfoByProviderPlatformEtender",
            //   link: "/Reports/GetAuctionInfoByProviderPlatformEtender",
            //   parentId: 42,
            //   visible:true
            // },
            {
              id: 52,
              label: "AuctionInfoByBuyer",
              // link: "/Reports/AuctionInfoByBuyer",
              parentId: 42,
              visible: this.$can(
                "GetReportPurchaseRequisitionView",
                "permissions"
              ),
              subItems:[
              {
              label: "GetAuctionInfoByBuyerPlatfromAuction",
              link: "/Reports/GetAuctionInfoByBuyerPlatfromAuction",
              parentId: 52,
              visible:true
            },
            {
              label: "GetAuctionInfoByBuyerPlatfromShop",
              link: "/Reports/GetAuctionInfoByBuyerPlatfromShop",
              parentId: 52,
              visible:true
            },
            {
              label: "GetAuctionInfoByBuyerPlatfromEtender",
              link: "/Reports/GetAuctionInfoByBuyerPlatfromEtender",
              parentId: 52,
              visible:true
            },
              ]
            },
            // {
            //   // id: 51,
            //   label: "GetAuctionInfoByBuyerPlatfromAuction",
            //   link: "/Reports/GetAuctionInfoByBuyerPlatfromAuction",
            //   parentId: 42,
            //   visible:true
            // },
            // {
            //   // id: 51,
            //   label: "GetAuctionInfoByBuyerPlatfromShop",
            //   link: "/Reports/GetAuctionInfoByBuyerPlatfromShop",
            //   parentId: 42,
            //   visible:true
            // },
            // {
            //   // id: 51,
            //   label: "GetAuctionInfoByBuyerPlatfromEtender",
            //   link: "/Reports/GetAuctionInfoByBuyerPlatfromEtender",
            //   parentId: 42,
            //   visible:true
            // },
            {
              id: 53,
              label: "topmaxeconomycostauctionlotinfo",
              link: "/Reports/TopMaxEconomyCostAuctionLotInfo",
              parentId: 42,
              visible: this.$can(
                "GetReportPurchaseRequisitionView",
                "permissions"
              ),
            },
            {
              id: 55,
              label: "topmaxparticipantscountauctionlotinfo",
              link: "/Reports/TopMaxParticipantsCountAuctionLotInfo",
              parentId: 42,
              visible: this.$can(
                "GetReportPurchaseRequisitionView",
                "permissions"
              ),
            },
            {
              id: 57,
              label: "topmaxlotcountauctioninfobyprovider",
              // link: "/Reports/TopMaxLotCountAuctionInfoByProvider",
              parentId: 42,
              visible:true,

              subItems:[
              {
              label: "GetTopMaxLotCountAuctionInfoByProviderPlatformAuction",
              link: "/Reports/GetTopMaxLotCountAuctionInfoByProviderPlatformAuction",
              parentId: 57,
              visible:true,
            },
            {
              label: "GetTopMaxLotCountAuctionInfoByProviderPlatformShop",
              link: "/Reports/GetTopMaxLotCountAuctionInfoByProviderPlatformShop",
              parentId: 57,
              visible:true,
            },
            {
              label: "GetTopMaxLotCountAuctionInfoByProviderPlatformEtender",
              link: "/Reports/GetTopMaxLotCountAuctionInfoByProviderPlatformEtender",
              parentId: 57,
              visible:true,
            },
              ]
            },
            {
              id: 58,
              label: "gettopmaxtotalcostauctioninfobyproviderplatformauction",
              parentId: 58,
              visible:true,

              subItems:[
              {
              label: "GetTopMaxTotalCostAuctionInfoByProviderPlatformAuction",
              link: "/Reports/GetTopMaxTotalCostAuctionInfoByProviderPlatformAuction",
              parentId: 58,
              visible:true,
            },
            {
              label: "GetTopMaxTotalCostAuctionInfoByProviderPlatformShop",
              link: "/Reports/GetTopMaxTotalCostAuctionInfoByProviderPlatformShop",
              parentId: 58,
              visible:true,
            },
            {
              label: "GetTopMaxTotalCostAuctionInfoByProviderPlatformEtender",
              link: "/Reports/GetTopMaxTotalCostAuctionInfoByProviderPlatformEtender",
              parentId: 58,
              visible:true,
            },
              ]
            },
            
            {
              id: 61,
              label: "BudgetAuction",
              link: "/Reports/BudgetAuctionList",
              parentId: 64,
              visible:true,

            //   subItems:[
            //   {
            //   id: 61,
            //   label: "BudgetAuctionList",
            //   link: "/Reports/BudgetAuctionList",
            //   parentId: 61,
            //   visible:true,
            // },
            // {
            //   label: "GetBudgetShopList",
            //   link: "/Reports/GetBudgetShopList",
            //   parentId: 61,
            //   visible: true,
            // },
            // {
            //   label: "GetBudgetEtenderList",
            //   link: "/Reports/GetBudgetEtenderList",
            //   parentId: 61,
            //   visible: true,
            // },
            //   ]
            },
            // {
            //   id: 61,
            //   label: "BudgetAuctionList",
            //   link: "/Reports/BudgetAuctionList",
            //   parentId: 64,
            //   visible:true,
            // },
            // {
            //   label: "GetBudgetShopList",
            //   link: "/Reports/GetBudgetShopList",
            //   parentId: 64,
            //   visible: true,
            // },
            // {
            //   label: "GetBudgetEtenderList",
            //   link: "/Reports/GetBudgetEtenderList",
            //   parentId: 64,
            //   visible: true,
            // },
            {
              id: 65,
              label: "BudgetTenderList",
              link: "/Reports/BudgetTenderList",
              parentId: 64,
              visible: this.$can(
                "GetReportPurchaseRequisitionView",
                "permissions"
              ),
            },
            {
              id: 60,
              label: "ProviderCard",
              link: "/Reports/ProviderCard",
              parentId: 42,
              visible: this.$can(
                "GetReportPurchaseRequisitionView",
                "permissions"
              ),
              visible: true,
            },
            {
              id: 66,
              label: "BuyerCard",
              link: "/Reports/BuyerCard",
              parentId: 42,
              visible: this.$can(
                "GetReportPurchaseRequisitionView",
                "permissions"
              ),
              visible: true,
            },
            {
              id: 45,
              label: "ReportPurchaseRequisition",
              link: "/Reports/ReportPurchaseRequisition",
              parentId: 42,
              visible: this.$can(
                "GetReportPurchaseRequisitionView",
                "permissions"
              ),
            },
          ],
        },
        {
          id: 65,
          label: "RiskManagement",
          isTitle: true,
        },
        {
          id: 64,
          label: "RiskManagement",
          icon: "bx bxs-report",
          subItems: [
            {
              id: 39,
              label: "GetLotsByDumpingRisk",
              link: "/Reports/GetLotsByDumpingRisk",
              parentId: 64,
              visible: this.$can(
                "GetReportPurchaseRequisitionView",
                "permissions"
              ),
            },
            {
              id: 38,
              label: "GetProvidersByCategoryRisk",
              link: "/Reports/GetProvidersByCategoryRisk",
              parentId: 64,
              visible: this.$can(
                "GetReportPurchaseRequisitionView",
                "permissions"
              ),
            },

            {
              id: 39,
              label: "GetBuyersByProviderRisk",
              link: "/Reports/GetBuyersByProviderRisk",
              parentId: 67,
              visible: this.$can(
                "GetReportPurchaseRequisitionView",
                "permissions"
              ),
            },
          ],
        },
        {
          id: 8,
          label: "Management",
          isTitle: true,
        },
        {
          id: 4,
          label: "Management",
          icon: "bx bx-cog toggle-right",
          subItems: [
            {
              id: 4,
              label: "organization",
              link: "/managment/organization",
              parentId: 4,
              visible: this.$can("OrganizationView", "permissions"),
            },
            {
              id: 1,
              label: "organizationtype",
              link: "/managment/organizationtype",
              parentId: 4,
              visible: this.$can("OrganizationTypeView", "permissions"),
            },
            {
              id: 3,
              label: "organizationaccount",
              link: "/managment/organizationaccount",
              parentId: 4,
              visible: this.$can("OrganizationAccountView", "permissions"),
            },
            {
              id: 5,
              label: "user",
              link: "/managment/user",
              parentId: 4,
              visible: this.$can("UserView", "permissions"),
            },
            {
              id: 2,
              label: "role",
              link: "/managment/role",
              parentId: 4,
              visible: this.$can("RoleView", "permissions"),
            },
          ],
        },
      ];
    },
  },
  mounted: function() {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu("#side-menu");
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    const paths = [];

    for (var i = 0; i < links.length; i++) {
      paths.push(links[i]["pathname"]);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf("/");
      const item = window.location.pathname.substr(0, strIndex).toString();
      matchingMenuItem = links[paths.indexOf(item)];
    } else {
      matchingMenuItem = links[itemIndex];
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            var childAnchor = parent3.querySelector(".has-arrow");
            var childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4 && parent4.id !== "side-menu") {
              parent4.classList.add("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5 && parent5.id !== "side-menu") {
                parent5.classList.add("mm-active");
                const childanchor = parent5.querySelector(".is-parent");
                if (childanchor && parent5.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  },
  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    hasItems1(item) {
      var itemVisible = 0;
      // console.log(this.menuItems);
      if (item.subItems !== undefined) {
        itemVisible = item.subItems.filter((el) => el.visible == false).length;
      }
      if (
        (item.subItems === undefined || item.subItems === null) &&
        item.visible == true
      ) {
        return false;
      }
      if (!!item.subItems) {
        return itemVisible == item.subItems.length ? false : true;
      }
    },

    toggleMenu(event) {
      event.currentTarget.nextElementSibling.classList.toggle("mm-show");
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <template v-for="item in menuItems">
        <li class="menu-title" v-if="item.isTitle" :key="item.id">
          {{ $t(item.label) }}
        </li>
        <li v-if="!item.isTitle && !item.isLayout" :key="item.id">
          <a
            v-if="hasItems1(item)"
            href="javascript:void(0);"
            class="is-parent "
            :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
          >
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ $t(item.label) }}</span>
            <span
              :class="`badge rounded-pill bg-${item.badge.variant} float-end`"
              v-if="item.badge"
              >{{ $t(item.badge.text) }}</span
            >
          </a>

          <router-link
            :to="item.link"
            v-if="!hasItems(item)"
            class="side-nav-link-ref"
          >
            <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
            <span>{{ $t(item.label) }}</span>
            <span
              :class="`badge rounded-pill bg-${item.badge.variant} float-end`"
              v-if="item.badge"
              >{{ $t(item.badge.text) }}</span
            >
          </router-link>

          <ul v-if="hasItems(item)" class="sub-menu " aria-expanded="false">
            <li
              v-for="(subitem, index) of item.subItems"
              v-show="subitem.visible"
              :key="index"
            >
              <router-link
                :to="subitem.link"
                v-if="!hasItems(subitem)"
                class="side-nav-link-ref"
                >{{ $t(subitem.label) }}</router-link
              >
              <a
                v-if="hasItems(subitem)"
                class="side-nav-link-a-ref has-arrow"
                href="javascript:void(0);"
                >{{ $t(subitem.label) }}</a
              >
              <ul
                v-if="hasItems(subitem)"
                class="sub-menu mm-collapse"
                aria-expanded="false"
              >
                <li
                  v-for="(subSubitem, index) of subitem.subItems"
                  :key="index"
                >
                  <router-link
                    :to="subSubitem.link"
                    class="side-nav-link-ref"
                    >{{ $t(subSubitem.label) }}</router-link
                  >
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </template>
    </ul>
  </div>
  <!-- Sidebar -->
</template>
